import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface IBriefingSection {
    id: string;
    isQuiz: boolean;
    displayOrder: number;
    description: string;


    isExpanded?: boolean;
    count?: number;
}

export class BriefingSection implements IBriefingSection {

    constructor(data?: IBriefingSection) {
        if (data) this.update(data);
    }

    update(data: IBriefingSection): BriefingSection {
        mapData(data, { root: () => this });
        return this;
    }

    id: string = Utils.createKey(6);
    isQuiz: boolean = false;
    displayOrder: number = 0;
    description: string = "";


    isExpanded: boolean = true;  // todo - save this somehow (local storage?)
    count: number = 0;

}